// Central NC – No Contractor business constants & helpers

export const NC = {
  brand: "NC – No Contractor",
  tagline: "Honesty. Understanding. Responsibility.",
  phoneDisplay: "9828593301",
  phoneIntl: "919828593301",
  email: "aimchievers@gmail.com",
  address: "21 Basant Vihar B, Agra Road, Jamdoli, Jaipur, Rajasthan",
  city: "Jaipur",
};

export const telLink = `tel:+${NC.phoneIntl}`;
export const mailLink = `mailto:${NC.email}`;

export const whatsappLink = (message) =>
  `https://wa.me/${NC.phoneIntl}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

// Default WhatsApp greeting used by header/hero/contact buttons
export const defaultWhatsappMessage =
  "Hello NC – No Contractor, I would like to know more about your construction & renovation services.";

// Indian Rupee formatting
export const formatINR = (value) => {
  const num = Number(String(value).replace(/[^0-9.]/g, ""));
  if (!num || Number.isNaN(num)) return "";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(num);
};

export const openWhatsApp = (message) => {
  window.open(whatsappLink(message), "_blank", "noopener,noreferrer");
};
